import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import PencilIcon from 'assets/svgs/pencilIcon.svg';
import { getPersonnelRolesName } from 'shared/helpers';
import NotifySVG from 'assets/svgs/notify.svg';
import Config from 'core/config';

import CollapsibleStaffSection from './CollapsibleStaffSection';
import StaffPoolModal from './StaffPoolModal';
import './StaffPool.scss';
import http from '../../../core/services/http';

class StaffPool extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assignedSectionOpen: true,
      availableSectionOpen: true,
      invitesSectionOpen: true,
      isStaffPoolModalOpen: false,
      nowLink: '',
    };
    this.navigateToNow = this.navigateToNow.bind(this);
    this.personnelRolesName = getPersonnelRolesName();
  }

  componentDidMount() {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
    if (this.props.nowManagedFlag) {
      http
        .get(`${Config.apiUrl}/testcenterevent/${this.props.tcEvent.id}/orgpart`)
        .then((response) => {
          this.setState({
            nowLink: response[0],
          });
        });
    }
  }

  componentDidUpdate() {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }

  handleOpenStaffPoolModal = () => {
    this.setState({ isStaffPoolModalOpen: true });
  };

  handleCloseStaffPoolModal = () => {
    const { staffActions, tcEvent } = this.props;

    this.setState({
      isStaffPoolModalOpen: false,
    });

    staffActions.getInvitedEventStaff(tcEvent.id);
    staffActions.getTcEventStaff(tcEvent.id);
    staffActions.getAvailableTcStaff(tcEvent.id, { page: 0, limit: 200 });
  };

  navigateToNow() {
    const host = globalThis.location.hostname.replace('tcm', 'now');
    globalThis.location.href = `https://${host}/administration/users/orgPartId/${this.state.nowLink}`;
  }

  render() {
    const {
      staffGroups,
      nowManagedFlag,
      openNotifyModal,
      testCenterCycle,
      currentUserId,
      staffActions,
      tcEvent,
    } = this.props;
    const { assignedSectionOpen, availableSectionOpen, invitesSectionOpen, isStaffPoolModalOpen } =
      this.state;

    const hasAssignedStaff = Boolean(staffGroups.assignedStaff.length);
    return (
      <section className="staff-pool-container border-box-radius">
        <div className="staff-header">
          <h5>{this.props.t('staffAndRoomsManagement.staffPool.title')}</h5>
          {
            <button
              className="btn btn-action btn-small"
              onClick={nowManagedFlag ? this.navigateToNow : this.handleOpenStaffPoolModal}
              disabled={nowManagedFlag && !this.state.nowLink}>
              <PencilIcon />
              {nowManagedFlag
                ? this.props.t('staffAndRoomsManagement.staffPool.btnNowLabel')
                : this.props.t('staffAndRoomsManagement.staffPool.btnLabel')}
            </button>
          }
        </div>
        <div className="delimiter" />
        <button
          className={`notify-button btn-link`}
          disabled={!hasAssignedStaff}
          onClick={openNotifyModal}>
          <NotifySVG />
          {this.props.t('staffAndRoomsManagement.notifyStaff.notify')}
        </button>
        <CollapsibleStaffSection
          open={assignedSectionOpen}
          sectionTitle={this.props.t('staffAndRoomsManagement.staffPool.assignedTitle')}
          staffList={staffGroups.assignedStaff}>
          <div className="collapsible-assigned-staff">
            {staffGroups.assignedStaff.map((staff) => (
              <div
                key={`assigned-${staff.personnelId}`}
                className="staff-row"
                data-bs-toggle="popover"
                data-bs-placement="top"
                data-bs-trigger="hover"
                data-bs-boundary="window"
                data-bs-html
                data-bs-template='<div class="popover staff-tooltip" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>'
                data-bs-content={`
                   <div>
                     <div class="fw-bold">${staff.lastName}, ${staff.firstName}</div>
                     <div>${this.personnelRolesName[staff.roleName]} (${staff.roleShortName})</div>
                     ${staff.roomName ? `<div>${staff.roomName}</div>` : ''}
                   </div>
                   ${
                     staff.locationName
                       ? `<div class="location">${staff.locationName} ${
                           staff.locationArea ? `, ${staff.locationArea}` : ''
                         }</div>`
                       : ''
                   }
                `}>
                <div className="staff-information">
                  <div className="text-ellipsis fw-bold">
                    {staff.lastName}, {staff.firstName}
                  </div>
                  <div className="text-ellipsis room-name">{staff.roomName}</div>
                </div>
                <div>
                  <div className="label-box-radius">{staff.roleShortName}</div>
                </div>
              </div>
            ))}
          </div>
        </CollapsibleStaffSection>

        <div className="delimiter" />

        <CollapsibleStaffSection
          open={availableSectionOpen}
          sectionTitle={this.props.t('staffAndRoomsManagement.staffPool.availableTitle')}
          staffList={staffGroups.availableToAssign}
        />
        <div className="delimiter" />

        <CollapsibleStaffSection
          open={invitesSectionOpen}
          sectionTitle={this.props.t('staffAndRoomsManagement.staffPool.invitesTitle')}
          staffList={staffGroups.invitedEventStaff}
        />
        <StaffPoolModal
          testCenterCycle={testCenterCycle}
          currentUserId={currentUserId}
          modalIsOpen={isStaffPoolModalOpen}
          closeModal={this.handleCloseStaffPoolModal}
          staffActions={staffActions}
          tcEvent={tcEvent}
        />
      </section>
    );
  }
}

StaffPool.propTypes = {
  nowManagedFlag: PropTypes.bool.isRequired,
  staffGroups: PropTypes.shape({
    assignedStaff: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    invitedEventStaff: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    availableToAssign: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  openNotifyModal: PropTypes.func.isRequired,
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  staffActions: PropTypes.shape({
    getInvitedEventStaff: PropTypes.func,
    getTcEventStaff: PropTypes.func,
    getAvailableTcStaff: PropTypes.func,
  }).isRequired,
  testCenterCycle: PropTypes.shape({}).isRequired,
  currentUserId: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(StaffPool);
